export default "__VITE_ASSET__Dr36YpDT__"